// extracted by mini-css-extract-plugin
export default {"ConteneurInfo":"ConteneurInformation_ConteneurInfo__Zpfl+","stile":"ConteneurInformation_stile__ldixr","newSlil":"ConteneurInformation_newSlil__wLO4S"};